export default __webpack_public_path__ + "static/media/Qualidade-PT.6ced99da.png";